import React, { useState } from "react";
import { FaEnvelope, FaPhone, FaUser } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useSpring, animated } from "@react-spring/web";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import logoImage from "./img/soikud.png";
import "./styles/ForgotPassword.css";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [phone, setPhone] = useState("");
  const navigate = useNavigate();

  // React Spring Animations
  const containerProps = useSpring({
    opacity: 1,
    from: { opacity: 0 },
    config: { duration: 1500 },
  });

  const boxProps = useSpring({
    transform: "translateY(0)",
    opacity: 1,
    from: { transform: "translateY(-50px)", opacity: 0 },
    config: { tension: 180, friction: 12 },
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newRequest = {
      email,
      name,
      surname,
      phone,
      type: "Şifre Sıfırlama",
      date: new Date().toISOString(),
    };

    try {
      // Production'da IIS reverse proxy kullan - /api istekleri otomatik olarak backend'e proxy ediliyor
      const response = await fetch('/api/pending-requests', {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(newRequest),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || "Bilinmeyen bir hata oluştu.");
      }

      toast.success("Şifre sıfırlama talebiniz başarıyla alındı!");
      setTimeout(() => navigate("/login"), 3000);
    } catch (error) {
      console.error("Başvuru gönderme hatası:", error);
      toast.error(error.message);
    }
  };

  return (
    <animated.div
      className="forgot-password-background"
      style={{ ...containerProps }}
    >
      <animated.div className="forgot-password-box" style={boxProps}>
        <div className="forgot-password-logo">
          <img src={logoImage} alt="Soikud Logo" className="login-logo" />
        </div>
        <h2>Şifremi Unuttum</h2>
        <form onSubmit={handleSubmit}>
          <div className="forgot-password-form-group">
            <i className="forgot-password-icon">
              <FaUser />
            </i>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              placeholder="Ad"
            />
          </div>
          <div className="forgot-password-form-group">
            <i className="forgot-password-icon">
              <FaUser />
            </i>
            <input
              type="text"
              value={surname}
              onChange={(e) => setSurname(e.target.value)}
              required
              placeholder="Soyad"
            />
          </div>
          <div className="forgot-password-form-group">
            <i className="forgot-password-icon">
              <FaPhone />
            </i>
            <input
              type="text"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              required
              placeholder="Telefon Numarası"
            />
          </div>
          <div className="forgot-password-form-group">
            <i className="forgot-password-icon">
              <FaEnvelope />
            </i>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="Email Adresi"
            />
          </div>
          <button type="submit" className="forgot-password-submit-button">
            Talep Gönder
          </button>
          <button
            type="button"
            className="forgot-password-login-button"
            onClick={() => navigate("/login")}
          >
            Giriş Yap
          </button>
        </form>
        <ToastContainer />
      </animated.div>
    </animated.div>
  );
};

export default ForgotPassword;
